import React, { useState } from 'react';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import NumberInput from '../../../shared/NumberInput';

const SIZE_FIELDS = [
  { key: 'width_mm', placeholder: 'W', title: 'Width (mm)' },
  { key: 'height_mm', placeholder: 'H', title: 'Height (mm)' },
];

const str = (v) => (v === null || v === undefined ? '' : String(Number(v)));

// Add/Edit one Label Size (issue #305): a name, plus the label's width and
// height in mm as it comes off the roll (width across the printer).
function LabelSizeForm({ initial, onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [size, setSize] = useState({ width_mm: str(initial?.width_mm), height_mm: str(initial?.height_mm) });
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return setError('Name is required.');
    if (!size.width_mm || !size.height_mm) return setError('Width and Height are required.');
    setError('');
    return onSave({ name: name.trim(), width_mm: size.width_mm, height_mm: size.height_mm });
  };

  return (
    <form onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        <div>
          <label>Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            placeholder="e.g., 69 × 48 mm"
            style={{ width: 260 }}
          />
        </div>
        <div>
          <label>Width × Height (mm)<RequiredMark /></label><br />
          <div style={{ display: 'flex', gap: 8, width: 200 }}>
            {SIZE_FIELDS.map(({ key, placeholder, title }) => (
              <NumberInput
                key={key}
                decimals={1}
                step="0.1"
                min={10}
                max={300}
                placeholder={placeholder}
                title={title}
                value={size[key]}
                onChange={(e) => setSize((prev) => ({ ...prev, [key]: e.target.value }))}
                style={{ flex: 1, minWidth: 0 }}
              />
            ))}
          </div>
        </div>
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default LabelSizeForm;
